import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import patrolDetails from './Layouts/patrolTasksDetails';
import PatrolForm from './Layouts/virtualPatrolform';
import LayoutWithMap from 'containers/Base/LayoutWithMap';
import {
  patrolDataGridActions,
  patrolTaskSelectors,
  patrolFilterActions,
  patrolTasksNS,
  patrolPageActions,
} from 'containers/Pages/Tasks/Patrols';
import { getSecurityCompanyId } from 'reducers/securityCompany';
import { getUserAssignedDepartmentList, getUserRoles } from 'reducers/users';
import { modalState, toggleModal } from 'reducers/ui';
import { ManagerAndAbove, userHasRole } from 'utils/helper/roles';
import { filters } from './filters';
import { columns } from './columns';
import useFilters from 'containers/Base/useFilters';

const BasePatrolTasks = ({
  defaultFilterValues = {},
  patrolfilters = filters,
  details = patrolDetails,
  FormComponent = PatrolForm,
}) => {
  //actions----------------
  const dispatch = useDispatch();
  const dispatchFetchPatrolReportList = useCallback(
    ({ filters, from }) => {
      dispatch(patrolDataGridActions.fetchGridList({ filters, from }));
    },
    [dispatch],
  );
  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(patrolTasksNS)),
    [dispatch],
  );
  const dispatchPrintPatrolList = useCallback(
    filters => {
      dispatch(patrolPageActions.printList(filters));
    },
    [dispatch],
  );
  //Selectors--------------
  const loading = useSelector(state => state.ui.loading);
  const userRoles = useSelector(state => getUserRoles(state));
  const filterValues = useSelector(state =>
    patrolTaskSelectors.getPatrolTaskListTransformed(state),
  );
  const forceRefresh = useSelector(state =>
    patrolTaskSelectors.getForceRefresh(state),
  );
  const totalRows = useSelector(state =>
    patrolTaskSelectors.getTotalRowsCount(state),
  );

  const patrolList = useSelector(state =>
    patrolTaskSelectors.getPatrolTaskListTransformed(state),
  );
  const securityCompanyId = useSelector(state => getSecurityCompanyId(state));
  const userAssignedDepartments = useSelector(state =>
    getUserAssignedDepartmentList(state),
  );
  const modalOpen = useSelector(state => modalState(state));
  //------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues: {
      ...filterValues,
      status: defaultFilterValues.status,
    },
  });

  const onUpdate = filters => {
    dispatchFetchPatrolReportList({ filters });
  };
  const onDownloadClick = () => {
    dispatchPrintPatrolList({ filters: localFilterValues });
  };
  const fetchPatrol = from => {
    dispatchFetchPatrolReportList({
      filters: localFilterValues,
      from,
    });
  };

  const PatrolTaskFormComponent = useCallback(
    props => (
      <FormComponent
        {...props}
        // userAssignedDepartments={userAssignedDepartments}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  return (
    <LayoutWithMap
      header="Patrols"
      editable={true}
      cols={columns}
      data={patrolList}
      totalEntries={totalRows}
      fetchData={fetchPatrol}
      loading={loading}
      toggleModal={dispatchToggleModal}
      onEdit={modalOpen[patrolTasksNS]}
      onUpdate={onUpdate}
      // render filters
      filtersRequired={true}
      filters={patrolfilters({
        securityCompanyId,
        userAssignedDepartments,
      })}
      forceRefresh={forceRefresh}
      filterValues={localFilterValues}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            patrolFilterActions.setFilterKey(true);
            patrolFilterActions.setFilters(filters);
          },
        })
      }
      DetailComponent={details}
      FormComponent={PatrolTaskFormComponent}
      //print the list item
      downloadable={userHasRole({
        userRoles: userRoles,
        requiredRoles: ManagerAndAbove,
      })}
      onDownloadClick={onDownloadClick}
      defaultFilterValues={defaultFilterValues}
    />
  );
};

BasePatrolTasks.propTypes = {
  details: PropTypes.elementType,
  filters: PropTypes.func,
  patrolfilters: PropTypes.func,
  editable: PropTypes.bool,
  downloadable: PropTypes.bool,
  onEdit: PropTypes.bool,
  defaultFilterValues: PropTypes.object,
  loading: PropTypes.bool,
  columns: PropTypes.array,
  FormComponent: PropTypes.elementType,
};

export default BasePatrolTasks;
